export default {
  $broadcast: function () {},
};
